import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { FilterMenuCheckboxList as FilterMenuCheckboxListLegacy } from './_do_not_import_/FilterMenuCheckboxList';
import {
  FilterMenuCheckboxList as FilterMenuCheckboxListV2,
  IFilterMenuCheckboxListProps,
} from './_do_not_import_v2_/FilterMenuCheckboxList';

export const FilterMenuCheckboxList = (props: IFilterMenuCheckboxListProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterMenuCheckboxListV2 {...props} />;
  }

  return <FilterMenuCheckboxListLegacy {...props} />;
};
